import { alpha } from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PRIMARY_COLOR } from "../../constants/colors";
import { NavOptions } from "../../constants/options";
import { TMenuItem } from "../../@types/common";

export default function BottomNavBar() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const iconStyle = { marginBottom: 3, fontSize: 20 };

  const options = NavOptions();
  // const { pathname } = useLocation();
  // const selected =
  //   pathname === `/${options?.[value]?.to}`?.replaceAll("//", "/");

  // useEffect(() => {

  // }, [pathname]);

  return (
    <Wrapper className="x100">
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        {options.map(
          ({ label, icon: Icon, to, visible = true }: TMenuItem, i: any) =>
            visible && (
              <BottomNavigationAction
                sx={{ textTransform: "capitalize" }}
                key={i}
                onClick={() => navigate(to)}
                label={label}
                icon={<Icon style={iconStyle} />}
              />
            )
        )}
      </BottomNavigation>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  bottom: 0;
  position: fixed;
  z-index: 1000;
  display: none;
  border-top: 1px solid ${alpha(PRIMARY_COLOR, 0.05)};

  @media (max-width: 960px) {
    display: block;
  }
`;
